import Validate from '../../../../libs/validate';

export function isValidUrl(urlValue) {
  return !!Validate.validate(Validate.TYPES.LINK, urlValue);
}

export function isCSVFile(fileName) {
  return fileName.endsWith('.csv');
}
